import { useMemo } from "react";

const fieldsPart1 = [
    "description",
    "color",
    "showUnallocatedDefaultPayCode",
    "preventTimeClockToTimesheet",
    "status",
    "startDay",
    "timesheetMethod",
    "useEmployeeTypeAsDefaultPayCode",
    "regularDefaultPayCode",
    "splitOvernight",
    "unallocatedDefaultPayCode",
    "isMain"
];

const fieldsPart2 = ["rounding", "geofenceLocation", "gpsLocation", "signature", "webcamOnMobile"];

export const useCommonFields = ({ data, type }) => {
    const fieldsPart = type === "part-1" ? fieldsPart1 : fieldsPart2;

    const result = useMemo(() => {
        return fieldsPart.map((field) => ({
            value: data[field],
            label: field.replace(/([A-Z])/g, "-$1").toLowerCase(),
        }));
    }, [data, fieldsPart]);

    return result;
};
